/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from './authentication-wam/authentication-wam.component.ngfactory';
import * as i2 from '../../app/authentication-wam/user.service';
import * as i3 from '../../app/config/app.config';
import * as i4 from '../../app/authentication-wam/authentication-wam.component';
import * as i5 from '../../app/authentication-wam/authentication-wam.service';
import * as i6 from '@angular/router';
import * as i7 from '@angular/http';
import * as i8 from '../../app/app.component';
const styles_AppComponent:any[] = ([] as any[]);
export const RenderType_AppComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,styles:styles_AppComponent,
    data:{}});
export function View_AppComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),2,'app-authentication-wam',
      ([] as any[]),(null as any),(null as any),(null as any),i1.View_AuthenticationWamComponent_0,
      i1.RenderType_AuthenticationWamComponent)),i0.ɵprd(512,(null as any),i2.UserService,
      i2.UserService,[i3.AppConfig]),i0.ɵdid(114688,(null as any),0,i4.AuthenticationWamComponent,
      [i5.AuthenticationWamService,i6.ActivatedRoute,i6.Router,i7.Http,i2.UserService],
      (null as any),(null as any)),(_l()(),i0.ɵted((null as any),['\n']))],(_ck,_v) => {
    _ck(_v,2,0);
  },(null as any));
}
export function View_AppComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'div',[['gpis-spa',
      '']],(null as any),(null as any),(null as any),View_AppComponent_0,RenderType_AppComponent)),
      i0.ɵdid(49152,(null as any),0,i8.AppComponent,([] as any[]),(null as any),(null as any))],
      (null as any),(null as any));
}
export const AppComponentNgFactory:i0.ComponentFactory<i8.AppComponent> = i0.ɵccf('[gpis-spa]',
    i8.AppComponent,View_AppComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiQzovVXNlcnMvUEJBQkg3L1dvcmtzcGFjZS9PblByZW1DaGluYS9QYWNrSVRXZWJHdWkvc3JjL2FwcC9hcHAuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL0M6L1VzZXJzL1BCQUJINy9Xb3Jrc3BhY2UvT25QcmVtQ2hpbmEvUGFja0lUV2ViR3VpL3NyYy9hcHAvYXBwLmNvbXBvbmVudC50cyIsIm5nOi8vL0M6L1VzZXJzL1BCQUJINy9Xb3Jrc3BhY2UvT25QcmVtQ2hpbmEvUGFja0lUV2ViR3VpL3NyYy92aWV3cy9tYXN0ZXJwYWdlLmh0bWwiLCJuZzovLy9DOi9Vc2Vycy9QQkFCSDcvV29ya3NwYWNlL09uUHJlbUNoaW5hL1BhY2tJVFdlYkd1aS9zcmMvYXBwL2FwcC5jb21wb25lbnQudHMuQXBwQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPGFwcC1hdXRoZW50aWNhdGlvbi13YW0+PC9hcHAtYXV0aGVudGljYXRpb24td2FtPlxyXG4iLCI8ZGl2IGdwaXMtc3BhPjwvZGl2PiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztvQkNBQTtNQUFBOzhDQUFBO3FCQUFBLHVCQUFBO01BQUE7TUFBQSw2QkFBaUQ7SUFBakQ7Ozs7b0JDQUE7TUFBQTthQUFBOzs7OyJ9



// WEBPACK FOOTER //
// C:/Users/PBABH7/Workspace/OnPremChina/PackITWebGui/src/$$_gendir/app/app.component.ngfactory.ts